module.exports = __webpack_public_path__ + "static/media/hadoop.4c2ae84d.svg";